import App from 'app/app.js';

function LtDateOnlyFilter() {
  return function (val) {
    if (val && val.length > 16) {
      return val.substring(0, 16);
    }
    return val;
  };
}

App.filter('LtDateOnlyFilter', [LtDateOnlyFilter]);
